import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '../../../assets/styles/colors';

export const ButtonAprovar = styled(Button)`
	background-color: ${color.yellow};
	border-radius: 50;
	width: 15vw;
	height: 3vh;
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		text-align: center;
		//padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;
